import { render, staticRenderFns } from "./manutencao-listagem.vue?vue&type=template&id=53be3d6b&"
import script from "./manutencao-listagem.vue?vue&type=script&lang=ts&"
export * from "./manutencao-listagem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports